import Api from "../services/AxiosService";

// svc-11 `POST /v1/analytics/ui/event` — public UI telemetry via the gateway
// (ADR-0004: single base URL; the Axios interceptor attaches the JWT so the
// server can resolve user_email / is_internal). Fire-and-forget: must never
// throw and never block UI interactions.

export type UiAnalyticsEventName =
  | "page_view"
  | "rfq_modal_opened"
  | "quote_download_clicked"
  | "quote_docx_download_clicked"
  | "support_assistant_shown"
  | "support_assistant_action"
  | "support_assistant_dismissed"
  | "progress_made";

export interface UiAnalyticsEventProps {
  ua?: string | null;
  title?: string | null;
  region?: string | null;
  hasTask?: boolean | null;
  solutionName?: string | null;
  productId?: string | null;
  reason?: string | null;
  action?: string | null;
  via?: string | null;
  msSinceLastProgress?: number | null;
}

const SESSION_KEY = "analytics_sid";

function getSessionId(): string | null {
  try {
    let sid = sessionStorage.getItem(SESSION_KEY);
    if (!sid) {
      sid = "s_" + Math.random().toString(36).slice(2, 12) + Date.now().toString(36);
      sessionStorage.setItem(SESSION_KEY, sid);
    }
    return sid;
  } catch {
    return null;
  }
}

export function trackEvent(
  name: UiAnalyticsEventName,
  props: UiAnalyticsEventProps = {},
): void {
  try {
    void Api.post("/v1/analytics/ui/event", {
      name,
      sessionId: getSessionId(),
      path: window.location.pathname + window.location.search,
      props,
    }).catch(() => undefined);
  } catch {
    // analytics must never break UX
  }
}
